import type { CustomIconProps } from '../CustomIcon';

export const WalletIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <rect
      x='3'
      y='7'
      width='18'
      height='12'
      rx='2'
      stroke={color}
      fill={color}
      strokeWidth='1.5'
      strokeLinejoin='round'
    />
    <path
      d='M3.5 5L16.6815 2.87395C17.8975 2.67783 19 3.61679 19 4.84843V5'
      stroke={secondaryColor}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle cx='17' cy='13' r='1' fill={secondaryColor} />
  </svg>
);
